import { updateContact as UPDATE_CONTACT } from '@admiin-com/ds-graphql';
import { gql, useMutation } from '@apollo/client';
import { MutationTuple, OperationVariables } from '@apollo/client';

type UpdateContactMutationTuple = MutationTuple<any, OperationVariables>;

export function useUpdateContact(): [
  UpdateContactMutationTuple[0],
  {
    error: UpdateContactMutationTuple[1]['error'];
    isLoading: UpdateContactMutationTuple[1]['loading'];
    data: UpdateContactMutationTuple[1]['data'];
  }
] {
  const [updateContact, { error, loading, data }] = useMutation(
    gql(UPDATE_CONTACT),
    {}
  );

  return [updateContact, { error, isLoading: loading, data }];
}
